import { nagMap } from 'chessboard/model/annotation/config';

/**
 * Convert NAG string PGN annotations
 */
export function convertNagsToAnnotations(pgn: string): string {
  let formattedPGN = pgn;

  Object.keys(nagMap)
    .reverse()
    .forEach((key) => {
      formattedPGN = formattedPGN.replace(new RegExp(`\\${key}`, 'gm'), nagMap[key]);
    });

  return formattedPGN;
}
